// ! TODO - use axios
// import axios from "axios";

export default function Send(url, body) {
    body = body ? JSON.stringify(body) : null;

    return fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
    })
        .then(r => r.json())
        .catch(e => {
            throw new Error(e);
        });
}
